import { useCallback } from "react";
import React from "react";
import { Button } from "@zapier/design-system";
import type { CopilotUserMessage } from "@zapier/canvas-state";
import styles from "../shared/buttonStyles.module.css";

export function ContinueButton() {
  const handleButtonClick = useCallback(async () => {
    // Send continue message via window.postMessage
    // This will be picked up by useCopilotToolMessageListener
    const message: CopilotUserMessage = {
      type: "COPILOT_USER_MESSAGE",
      payload: {
        source: "continue-button",
        messageType: "text",
        message: "Continue",
      },
    };
    window.postMessage(message, "*");
  }, []);

  return (
    <div className={styles.container}>
      <Button variant="primary" size="medium" onPress={handleButtonClick}>
        Continue
      </Button>
    </div>
  );
}
